import { FC, ReactChild } from 'react'

interface ConditionalWrapperProps {
  children?: ReactChild
  wrapper: (children?: ReactChild) => JSX.Element
  p: boolean
}

interface PredicateAndChild {
  p: boolean
  className?: string
  children?: ReactChild
}

const ConditionalWrapper: FC<ConditionalWrapperProps> = ({ children, p, wrapper }) => (
  p ? wrapper(children) : <>{children}</>
)

export const ConditionalUnderline: FC<PredicateAndChild> = ({ p, children }) => (
  <ConditionalWrapper
    p={p}
    wrapper={(innerChildren) => <u>{innerChildren}</u>}
  >
    {children}
  </ConditionalWrapper>
)
export const ConditionalBold: FC<PredicateAndChild> = ({ p, className = '', children }) => (
  <ConditionalWrapper
    p={p}
    wrapper={(innerChildren) => <b className={className}>{innerChildren}</b>}
  >
    {children}
  </ConditionalWrapper>
)

export default ConditionalWrapper
